import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DevicesReport } from '../../../../../models/DevicesReportModels';
import {
  setDeviceToAssign,
  updateRequest,
  updateSelectedDropdownDevice,
} from '../../../../../stores/AssignDeviceStore';
import { RootState } from '../../../../../stores/Store';

import TextInput from '../../../../../components/TextInput/TextInput';
import Button from '../../../../../components/Button/Button';
import ButtonGroup from '../../../../../components/ButtonGroup/ButtonGroup';
import AutoComplete from '../../../../../components/AutoComplete/AutoComplete';
import useAssignDeviceSelectDeviceStep from './useAssignDeviceSelectDeviceStep';

interface AssignDeviceSelectDeviceStepProps {
  nextStep: () => void;
  onClose: () => void;
}
function AssignDeviceSelectDeviceStep({ nextStep, onClose }: AssignDeviceSelectDeviceStepProps) {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { selectedDropdownDevice } = useSelector((state: RootState) => state.assignDeviceReducer);
  const [eSimDevice, setESimDevice] = useState<DevicesReport | null | undefined>(null);
  const [query, setQuery] = useState(selectedDropdownDevice.label);
  const { deviceOptions, isLoading } = useAssignDeviceSelectDeviceStep(query as string);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ paddingBottom: '2rem' }}>
        <Box sx={{ paddingBottom: '1.5rem' }}>
          <AutoComplete
            onInputChange={(val) => setQuery(val as string)}
            value={selectedDropdownDevice}
            placeholder={t('pages.userDetails.assignDeviceDrawer.inputPlaceholder')}
            label={t('pages.userDetails.assignDeviceDrawer.inputLabel')}
            onChange={(e) => {
              setESimDevice(e.data as DevicesReport);
              dispatch(updateSelectedDropdownDevice(e));
              dispatch(setDeviceToAssign(e.data as DevicesReport));
              dispatch(updateRequest({ deviceId: e.value as string }));
            }}
            isLoading={isLoading}
            options={deviceOptions}
          />
        </Box>
        {eSimDevice ? (
          <>
            <TextInput
              id="model"
              name="model"
              onInputChange={() => {}}
              value={eSimDevice.model}
              placeholder={t('pages.userDetails.assignDeviceDrawer.model')}
              label={t('pages.userDetails.assignDeviceDrawer.model')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
            <TextInput
              id="manufacturer"
              name="manufacturer"
              onInputChange={() => {}}
              value={eSimDevice.manufacturer}
              placeholder={t('pages.userDetails.assignDeviceDrawer.manufacturer')}
              label={t('pages.userDetails.assignDeviceDrawer.manufacturer')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
            <TextInput
              id="type"
              name="type"
              onInputChange={() => {}}
              value={eSimDevice.type}
              placeholder={t('pages.userDetails.assignDeviceDrawer.type')}
              label={t('pages.userDetails.assignDeviceDrawer.type')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
            <TextInput
              id="eid"
              name="eid"
              onInputChange={() => {}}
              value={eSimDevice.eid}
              placeholder={t('pages.userDetails.assignDeviceDrawer.eid')}
              label={t('pages.userDetails.assignDeviceDrawer.eid')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
            <TextInput
              id="imeiOne"
              name="imeiOne"
              onInputChange={() => {}}
              value={eSimDevice.imeiOne}
              label={t('pages.userDetails.assignDeviceDrawer.imeiOne')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
            <TextInput
              id="imeiTwo"
              name="imeiTwo"
              onInputChange={() => {}}
              value={eSimDevice.imeiTwo}
              label={t('pages.userDetails.assignDeviceDrawer.imeiTwo')}
              disabled
              formStyle={{ paddingBottom: '1.5rem' }}
            />
          </>
        ) : null}
      </Box>
      <Box sx={{ marginTop: 'auto' }}>
        <ButtonGroup>
          <Button label={t('common.cancel')} color="alternative2Button" onClick={onClose} />
          <Button
            label={t('common.continue')}
            color="primaryButton"
            disabled={!selectedDropdownDevice.key}
            onClick={nextStep}
          />
        </ButtonGroup>
      </Box>
    </Box>
  );
}

export default AssignDeviceSelectDeviceStep;
